import { lazy } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "@/infra/router/ProtectedRoute";
import { dashboardRoutes } from "@/pages/dashboard/routes";
import { PROTECTED_ONBOARDING_ROUTES } from "@/pages/onboarding/routes";
import { sessionRoutes, selfReflectionRoutes } from "@/pages/sessions/routes";
import { settingsRoutes } from "@/pages/settings/routes";

const SettingsLayout = lazy(() => import("@/components/settings/SettingsLayout"));
const NavigationBarLayout = lazy(() => import("@/components/navigation/NavigationBarLayout"));
const SelfReflectionBaseLayout = lazy(() => import("@/components/self-reflection/layouts/SelfReflectionBaseLayout"));


export const PROTECTED_ROUTES = [
  <Route key="protected" element={<ProtectedRoute />}>
    {PROTECTED_ONBOARDING_ROUTES}

    <Route element={<NavigationBarLayout />}>
      {dashboardRoutes}
      <Route element={<SettingsLayout />}>{settingsRoutes}</Route>
    </Route>
    <Route element={<SelfReflectionBaseLayout />}>{selfReflectionRoutes}</Route>
    {sessionRoutes}
  </Route>,
];
